export default __webpack_public_path__ + "static/media/edit_square.ffb23288.svg";